import { useState, useEffect } from 'react';

const whatsappUrl =
  'https://wa.me/543513495570?text=Hola.%20Quisiera%20hablar%20con%20un%20abogado%20por%20un%20asunto%20legal.';

export default function FloatingWhatsApp() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      className={`fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full shadow-lg transition-all duration-500 ease-out cursor-pointer group ${
        visible
          ? 'opacity-100 translate-y-0 scale-100'
          : 'opacity-0 translate-y-6 scale-75'
      }`}
      style={{ backgroundColor: '#25D366' }}
    >
      <i className="ri-whatsapp-line text-white text-2xl md:text-3xl"></i>

      {/* Pulse ring */}
      <span
        className="absolute inset-0 rounded-full animate-ping opacity-25 pointer-events-none"
        style={{ backgroundColor: '#25D366' }}
      />

      {/* Tooltip */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-foreground-900 text-white text-xs md:text-sm font-medium px-3 py-1.5 rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
        ¿Necesitas asesoramiento legal?
      </span>
    </a>
  );
}